"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _getLang = _interopRequireDefault(require("I18n/utils/getLang"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIApplication = _interopRequireDefault(require("UIComponents/app/UIApplication"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _MarketingNavHeader = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/MarketingNavHeader"));

var _MarketingNavFooter = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/MarketingNavFooter"));

var _useWindowDimensionsContext = require("ecosystem-marketplace-core/hooks/useWindowDimensionsContext");

var _useShortlinkParams = _interopRequireDefault(require("../utils/hooks/useShortlinkParams"));

var _urls = require("../utils/urls");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-height: 100vh;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.publicApplication." + key;
};

var StyledUIApplication = (0, _styledComponents.default)(_UIApplication.default).withConfig({
  displayName: "PublicApplication__StyledUIApplication",
  componentId: "sc-8o8agv-0"
})(_templateObject());
var StyledMainContent = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_UIBox.default, (0, _extends2.default)({}, props, {
    grow: 1,
    shrink: 1
  }));
}).withConfig({
  displayName: "PublicApplication__StyledMainContent",
  componentId: "sc-8o8agv-1"
})(_templateObject2());

var PublicApplication = function PublicApplication(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  var hostName = window.location.origin;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  var shortlinkParams = (0, _useShortlinkParams.default)();
  var lang = (0, _getLang.default)();
  var headerContentBlob = (0, _react.useMemo)(function () {
    var contactText = (0, _unescapedText.default)(getI18nKey('header.contactText'));
    var contactUrl = (0, _urls.getContactUrl)(lang);
    var ctaText = (0, _unescapedText.default)(getI18nKey('header.ctaText'));
    var ctaUrl = (0, _urls.getSignupUrl)(lang, pathname);
    return {
      upperNavContent: {
        loginUrl: (0, _urls.getAppShortlink)(pathname, shortlinkParams),
        loginText: (0, _unescapedText.default)(getI18nKey('header.loginText')),
        ctaUrl: ctaUrl,
        ctaText: ctaText,
        regionalDropdownContent: {
          contactUrl: contactUrl,
          contactText: contactText,
          languagesContent: {
            en: ['English', hostName, (0, _urls.getLocalizedPublicPath)('en', pathname)],
            jp: ['日本語', hostName, (0, _urls.getLocalizedPublicPath)('ja', pathname)],
            de: ['Deutsch', hostName, (0, _urls.getLocalizedPublicPath)('de', pathname)],
            es: ['Español', hostName, (0, _urls.getLocalizedPublicPath)('es', pathname)],
            pt: ['Português', hostName, (0, _urls.getLocalizedPublicPath)('pt', pathname)],
            fr: ['Français', hostName, (0, _urls.getLocalizedPublicPath)('fr', pathname)]
          }
        }
      },
      mobileNavContent: {
        contactUrl: contactUrl,
        contactText: contactText,
        ctaUrl: ctaUrl,
        ctaText: ctaText,
        searchPlaceholder: (0, _unescapedText.default)(getI18nKey('header.searchPlaceholder'))
      }
    };
  }, [hostName, lang, pathname, shortlinkParams]);

  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      windowWidth = _useWindowDimensionsC.width;

  var headerVariation = windowWidth < 768 ? 'default' : 'marketplace';
  return _react.default.createElement(StyledUIApplication, rest, _react.default.createElement(_UIBox.default, {
    grow: 0,
    shrink: 0
  }, _react.default.createElement(_MarketingNavHeader.default, {
    contentBlob: headerContentBlob,
    lang: lang,
    variation: headerVariation
  })), _react.default.createElement(StyledMainContent, null, children), _react.default.createElement(_UIBox.default, {
    grow: 0,
    shrink: 0
  }, _react.default.createElement(_MarketingNavFooter.default, {
    lang: lang
  })));
};

PublicApplication.propTypes = {
  children: _propTypes.default.node
};
var _default = PublicApplication;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/PublicApplication.js
// module id = 1176
// module chunks = 212